import { Box, Typography, Button, Paper } from '@mui/material'
import { Warning as WarningIcon } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'

interface FeatureUnavailableProps {
  featureName: string
  message?: string
}

export const FeatureUnavailable: React.FC<FeatureUnavailableProps> = ({ 
  featureName, 
  message = 'This feature is temporarily unavailable while we improve it.' 
}) => {
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
        p: 3
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 600,
          textAlign: 'center'
        }}
      >
        <WarningIcon
          sx={{
            fontSize: 80,
            color: 'warning.main',
            mb: 2
          }}
        />
        <Typography variant="h4" gutterBottom>
          {featureName} Unavailable
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          {message}
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          Expected availability: Coming soon
        </Typography>
        <Button
          variant="contained"
          onClick={() => navigate('/admin/products')}
          sx={{ mt: 2 }}
        >
          Go to Products
        </Button>
      </Paper>
    </Box>
  )
}
